var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticimax-filter-row-wrapper" },
    [
      _c(
        "a-popover",
        {
          attrs: {
            visible: _vm.selected,
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          on: {
            visibleChange: function (isVisible) {
              return isVisible ? _vm.onSelected() : _vm.onCanceled()
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("SingleFilterEditor", {
                attrs: { "on-closed": _vm.onCanceled, types: _vm.types },
                model: {
                  value: _vm.clone,
                  callback: function ($$v) {
                    _vm.clone = $$v
                  },
                  expression: "clone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "filter-row" }, [
            _c(
              "div",
              { staticClass: "filter-item", class: { active: _vm.selected } },
              [
                _c("div", { staticClass: "filter-remove" }, [
                  _c(
                    "div",
                    { staticClass: "control-button" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-icon-button md-mini",
                          on: {
                            click: function (e) {
                              e.stopPropagation()
                              _vm.onRemoved(_vm.clone.id)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("delete_outline")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-icon" },
                  [
                    _c("FieldIconPreview", {
                      attrs: { attribute: _vm.clone.attribute },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "filter-item-text",
                    attrs: {
                      content:
                        _vm.$t("ticimax.attributes." + _vm.clone.attribute) +
                        " " +
                        _vm.getOperatorName() +
                        " '" +
                        _vm.getAttributeValue() +
                        "'",
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("ticimax.attributes." + _vm.clone.attribute)
                          ) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getOperatorName()) +
                        "\n                    "
                    ),
                    _vm.isPayloadRequired()
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.getAttributeValue()) + " "),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      (_vm.addFilterMode ? _vm.showOperatorSelect : true)
        ? _c(
            "a-select",
            {
              class: { hovered: _vm.groupSelectHovered },
              attrs: { value: _vm.operator },
              on: {
                change: _vm.onOperatorChanged,
                click: function (e) {
                  e.stopPropagation()
                },
                mouseenter: function () {
                  return _vm.selectGroupHoverStateChanged(true)
                },
                mouseleave: function () {
                  return _vm.selectGroupHoverStateChanged(false)
                },
              },
            },
            [
              _c("a-select-option", { attrs: { value: "or" } }, [
                _vm._v(" " + _vm._s(_vm.$t("chatbotv2.or"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "and" } }, [
                _vm._v(" " + _vm._s(_vm.$t("chatbotv2.and"))),
              ]),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "filter-row small" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    trigger: "click",
                    placement: "left",
                    overlayClassName: "no-padding",
                  },
                  model: {
                    value: _vm.attributePickerVisible,
                    callback: function ($$v) {
                      _vm.attributePickerVisible = $$v
                    },
                    expression: "attributePickerVisible",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("FieldPicker", {
                        attrs: {
                          types: _vm.types,
                          "default-selected": null,
                          pick: _vm.onAttributePicked,
                          "filter-mode": true,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-filter-button" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" add "),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.addFilter")) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }